import { render, staticRenderFns } from "./content-before-buy.vue?vue&type=template&id=8b7f65f8&scoped=true&"
import script from "./content-before-buy.vue?vue&type=script&lang=ts&"
export * from "./content-before-buy.vue?vue&type=script&lang=ts&"
import style0 from "./content-before-buy.vue?vue&type=style&index=0&id=8b7f65f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7f65f8",
  null
  
)

export default component.exports